import React from "react";

const Footer = ({
    message,
    setMessage,
    onSubmit,
    onStartConversation,
    props,
}) => {
    const submitBtnRef = React.useRef(null);

    const handleTextareaHeight = (event) => {
        event.target.style.height = "auto";
        event.target.style.height = event.target.scrollHeight + "px";
    };

    const onEnterPress = (e) => {
        if (e.keyCode == 13 && e.shiftKey == false) {
            e.preventDefault();
            e.stopPropagation();
            submitBtnRef.current.click();
        }
    };

    return (
        <React.Fragment>
            <div className="chatbot-chatbox-footer">
                <form onSubmit={onSubmit}>
                    <textarea
                        rows="1"
                        autoComplete="off"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        className="chatbot-chatbox-message-input"
                        placeholder={props.messagePlaceholder}
                        onInput={handleTextareaHeight}
                        onKeyDown={onEnterPress}
                    ></textarea>
                    <button
                        type="submit"
                        ref={submitBtnRef}
                        className="chatbot-chatbox-message-submit"
                    >
                        <i className="fas fa-paper-plane"></i>
                    </button>
                </form>
                <div
                    className="chatbot-chatbox-start-bot-discussion"
                    onClick={onStartConversation}
                >
                    {props.promptStart}
                </div>
            </div>
        </React.Fragment>
    );
};

export default Footer;
